import { render, staticRenderFns } from "./LatestRacesPanel.vue?vue&type=template&id=1b6f5102&scoped=true"
import script from "./LatestRacesPanel.vue?vue&type=script&lang=js"
export * from "./LatestRacesPanel.vue?vue&type=script&lang=js"
import style0 from "./LatestRacesPanel.vue?vue&type=style&index=0&id=1b6f5102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f5102",
  null
  
)

export default component.exports